const chatbotPermissions = {
    chats: {
        index: (_session) => true,
        show: (_session) => true,
        own: (_session, chat) => {
            return !chat.assignedToId && chat.status === "WAITING";
        },
        send: (session, chat) => {
            return session.user.id === chat.assignedToId && chat.status !== "CLOSED";
        },
        close: (_session, chat) => {
            return chat.status !== "CLOSED";
        },
        assign: (_session, chat) => {
            return chat.status !== "CLOSED";
        },
    },
};
export default chatbotPermissions;
